import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

interface CreditsContextType {
  credits: number | null;
  refresh: () => Promise<void>;
  updateCredits: (newCredits: number) => void;
}

const CreditsContext = createContext<CreditsContextType>({ 
  credits: null, 
  refresh: async () => {}, 
  updateCredits: () => {} 
});

export const CreditsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [credits, setCredits] = useState<number | null>(null);
  const profile = useSelector((state: RootState) => state.auth.profile);

  const updateCredits = (newCredits: number) => {
    setCredits(newCredits);
  };

  // Sincronizar créditos con el perfil de Redux
  useEffect(() => {
    if (profile && typeof profile.credits === 'number') {
      setCredits(profile.credits);
    }
  }, [profile]);

  return (
    <CreditsContext.Provider value={{ credits, refresh: async () => {}, updateCredits }}>
      {children}
    </CreditsContext.Provider>
  );
};

export const useCredits = () => {
  const context = useContext(CreditsContext);
  if (context === undefined) {
    throw new Error('useCredits debe ser usado dentro de un CreditsProvider');
  }
  return context;
}; 